define('uikit/mixins/bind',['require','exports','module','marionette','underscore'],function(require, exports, module){
  var Mn = require('marionette');
  var _ = require('underscore');


  var BindMixin = {

    initialize: function() {
      this.bindings = _.extend({}, _.result(this, 'bindings'), _.result(this.options, 'bindings'));
      this.childBindings = _.extend({}, _.result(this, 'childBindings'), _.result(this.options, 'childBindings'));

      this.once('before:render', this._setupBindings, this);
      
      this._setupBindGetter();

      // Only applies to views that render children (Collection or Composite View)
      this.on('before:add:child', function(child) {

        // Sets up child bindings using the childBindings property
        child.bindings = _.extend({}, child.bindings, this.childBindings);
      }, this);
    },

    _setupBindGetter: function() {
      var bindings = this.getOption('bindings') || {},
          self     = this;

      if (bindings.hasOwnProperty('get')) {
        return;
      }

      Object.defineProperty(bindings, 'get', {
        get: function() {
          return function(viewField) {
            return self._getPropertyForBinding(viewField);
          };
        }
      });
    },

    _getPropertyForBinding: function(viewField) {
      var model    = this.getOption('model'),
          bindings = this.getOption('bindings');

      if (model) {

        return model.get(bindings[viewField]);
      }
      return null;
    },

    _setupBindings: function() {
      if (!this.model) { return; }
      var bindings = this.getOption('bindings') || {},
          model    = this.getOption('model');

      // define a get property
      this._setupBindGetter();
    }

  };

  _.extend(Mn.ItemView.prototype, BindMixin);

  module.exports = BindMixin;
});
